import { Component, Inject, OnInit, OnDestroy, ViewChild} from "@angular/core";
import { Utils } from "../../../utils/utils";
import { HttpClient } from "@angular/common/http";
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { InspectionFilterComponent } from "./inspection-filter.component";
import { InspectionListComponent } from "./inspection-list.component";
import { Subscription } from "rxjs";
import { SaveService } from '../../../services/save.service';
import { SignalRService } from "../../../services/signal-r";

@Component({
    selector: "inspection",
    templateUrl: './inspection.component.html',
    styleUrls: ['../../../style/container-tab-list.component.less'],
    standalone: false
})

export class InspectionComponent implements OnInit, OnDestroy {

    list: InspectionView[] = [];

    title = "Inspections";
    showLocalFilter = false;

    subscriptionStage: any;
    subscriptionTenant: any;
    subscriptions: Subscription[] = [];

    @ViewChild(InspectionListComponent, { static: true }) listComponent!: InspectionListComponent;
    @ViewChild(InspectionFilterComponent, { static: true }) filterComponent!: InspectionFilterComponent;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
        , public signalRService: SignalRService
        , private saveService: SaveService
    ) { }

    ngOnInit(): void {
        this.subscriptionStage = this.defaults.stageMessageChanges$.subscribe(() => {
            this.getFilteredInspectionsByTenant()
            this.listComponent.clonedList = {}
        });
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getFilteredInspectionsByTenant()
            this.listComponent.clonedList = {}
        });
        if (this.defaults.tenant)
            this.getFilteredInspectionsByTenant()
    }

    ngOnDestroy() {
        this.saveService.removeListener(this);
        this.subscriptionStage.unsubscribe();
        this.subscriptionTenant.unsubscribe();
        this.subscriptions.forEach(x => x.unsubscribe())
    }

    onReload() {
        this.getFilteredInspectionsByTenant();
        this.listComponent.clonedList = {}
        this.saveService.showSaveButton(false)
    }

    downloadInspectionFiltered() {
        const filter: InspectionFilter = {
            'InspectionIds': this.filterComponent.inspectionIds,
            'UnitIds': this.filterComponent.unitIds
        }
        Utils.httpDownloadInspections(
            this.http
            , this.baseUrl
            , this.defaults.stage
            , this.defaults.tenant
            , filter
            , this
            , null
        );
    }

    getFilteredInspectionsByTenant() {
        let filter: InspectionFilter = {
            'InspectionIds': this.filterComponent.inspectionIds,
            'UnitIds': this.filterComponent.unitIds
        }
        Utils.httpGetInspections(
            this.http
            , this.baseUrl
            , this.defaults.stage
            , filter
            , this
            , function (tthis: any, list: InspectionView[]) {
                tthis.list = list;
                tthis.listComponent.clonedList = {}
                tthis.listComponent.expandedElements = new Set();
                tthis.saveService.showSaveButton(false)
                if (filter.InspectionIds.length < 1 && filter.UnitIds.length < 1)
                    tthis.showLocalFilter = false;
                else
                    tthis.showLocalFilter = true;
            }
        );
    }
}